import { render, staticRenderFns } from "./page-2.vue?vue&type=template&id=5239f2e3&scoped=true&"
import script from "./page-2.vue?vue&type=script&lang=js&"
export * from "./page-2.vue?vue&type=script&lang=js&"
import style0 from "./page-2.vue?vue&type=style&index=0&id=5239f2e3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5239f2e3",
  null
  
)

export default component.exports